import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";

const NewsletterSignup: React.FC = () => {

    const klaviyoListId = process.env.REACT_APP_KLAVIYO_LIST_ID;
    const [isSignedUp, setIsSignedUp] = useState<boolean>(false);
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      setMessage("");
      setIsLoading(true);

      try {
        const trimmedEmail = email.toLowerCase().trim();

        // This is the correct path when deployed to Netlify
        const response = await fetch("/.netlify/functions/subscribe", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: trimmedEmail,
            listId: klaviyoListId,
          }),
        });

        // Handle the response
        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.message ??
              `Subscription failed with status: ${response.status}`
          );
        }

        setMessage("Successfully subscribed!");
        setEmail("");
        setIsSignedUp(true);
      } catch (error: any) {
        console.error("Newsletter subscription error:", error);
        setMessage(
          `Error: ${error.message || "Failed to subscribe. Please try again."}`
        );
        setIsSignedUp(false);
      } finally {
        setIsLoading(false);
      }
    };

    const handleDemoSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      setMessage("");
      setIsLoading(true);

      try {
        // Simulate API call
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          throw new Error("Please enter a valid email address");
        }

        setMessage("Successfully subscribed!");
        setEmail("");
        setIsSignedUp(true);
      } catch (error: any) {
        console.error("Newsletter subscription error:", error);
        setMessage(
          `Error: ${error.message || "Failed to subscribe. Please try again."}`
        );
        setIsSignedUp(false);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div className="newsletterWrap">
        <div className="contentLeft">
          <div className="headingBlk">Emails That Hit Harder Than Your RB2</div>
          <p>We'll send you only the good stuff — punishments, memes, and the worst fantasy fails of the week.</p>
        </div>
        <form
          className="newsletterForm"
          onSubmit={
            process.env.NODE_ENV === "development"
              ? handleDemoSubmit
              : handleSubmit
          }
        >
          <div className="formFldWrap">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
              className="fldStyle"
              required
            />
            <button type="submit" disabled={isLoading} className="btnStyle btnFilled">
              {isLoading ? "Submitting..." : "SIGN UP"}
            </button>
          </div>

          {message && (
            <div
              className={`formMsg ${
                message.startsWith("Error") ? "errorTxt" : "successTxt"
              }`}
            >
              {message}
            </div>
          )}
        </form>
      </div>
    );

}

export default NewsletterSignup;